<!-- Base Modal Product Component -->
<!-- Description: Creating a modal for the preview page -->
<template>
    <!-- Creating a modal -->
    <modal transition="pop-out" :name="'modal_' + product.id" :width="modalWidth" height="auto" :scrollable="true">
        <b-row style="">
            <b-col cols="12">
                <img alt="" :src="'https://api.foodninja.net'+ product.attributes.image" style="width: 100%;"/>
            </b-col>
            <b-col cols="12" style="padding-left: 0; margin-top: 10px; margin-bottom: 10px">
                <div style="margin-left: 15px;">
                    <h5 class="title margin-left">{{ product.attributes.name }}</h5>
                    <p class="margin-left">{{ product.attributes.description === 'null' ? '' : product.attributes.description }}</p>
                    <!-- Implementing an error list component (tag from './components/ui/BaseAlertList.vue') -->
                    <base-alert-list :errors="errors" style="margin-left: 15px; margin-right: 15px;"></base-alert-list>
                    <!-- Creating a size section -->
                    <div style="background: #ebebeb;">
                        <p class="margin-left title" style="padding-top: 20px; padding-bottom: 20px; font-size: 16px; margin-top: 15px; margin-bottom: 15px;">
                        Размер
                        </p>
                    </div>
                    <!-- Implementing an error list component (tag from '@/ui/BaseAlertList.vue') -->
                    <div class="margin-left" v-for="variation in product['product-variations']">
                        <input type="radio" name="demo" value="one" :id="'radio_' + variation.id" @click="selectVariation(variation)"
                               class="form-radio" :disabled="variation.attributes.is_active === '0'" :checked="selected.variation.id === variation.id"/>
                        <label :for="'radio_' + variation.id">
                            {{ Number(variation.attributes.weight).toFixed(0) }} {{ variation.attributes.weight_unit }} ({{ variation.attributes.price_with_vat }} лв.)
                        </label>
                    </div>
                    <!-- Implementing the preview ingredients component (tag from '../components/preview/modal/ThePreviewIngredients') -->
                    <the-preview-ingredients :product="product" :selected="selected" :show-ingredients="showIngredients" @ingredients="showIngredients = $event"/>
                    <!-- Implementing the preview addons component (tag from '../components/preview/modal/ThePreviewIngredients') -->
                    <the-preview-addons :product="product" :selected="selected"/>
                </div>
                <!-- Implementing the preview footer component (tag from './ThePreviewModalFooter') -->
                <the-preview-modal-footer :selected="selected" :ingredients="ingredients" :product="product" @newItem="$emit('newItem', $event)"/>
            </b-col>
        </b-row>
    </modal>
</template>

<!-- TypeScript code -->
<script>
    // Importing components
    import BaseAlertList from './BaseAlertList';
    import ThePreviewIngredients from '../components/preview/modal/ThePreviewIngredients';
    import ThePreviewAddons from '../components/preview/modal/ThePreviewAddons';
    import ThePreviewModalFooter from '../components/preview/modal/ThePreviewModalFooter';

    // Setting up constants
    const MODAL_WIDTH = 400;

    export default {
        name: 'BaseModalProduct',
        components: {
            ThePreviewModalFooter,
            ThePreviewAddons,
            ThePreviewIngredients,
            BaseAlertList,
        },
        data() {
            return {
                modalWidth: MODAL_WIDTH,
                selected: {},
                ingredients: [],
                errors: [],
                showIngredients: false,
            };
        },
        props: {
            name: String,
            product: Object,
        },
        methods: {
            selectVariation(variation) {
                this.selected.variation.id = variation.id;
                this.selected.variation.price = variation.attributes.price_with_vat;
            },
        },
        created() {
            this.ingredients = this.product.attributes.ingredients.map((item) => item.name);
            this.selected = {
                variation: {
                    id: '',
                    price: 0,
                },
                quantity: 1,
                ingredients: this.ingredients,
                addons: {},
            };
            for (const addon of this.product.attributes.addons) {
                this.$set(this.selected.addons, addon.name, []);
            }
            this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
        },
    };
</script>
<style scoped lang="scss">
    input[type][disabled] { background-color: #f9f9f9; color: #ddd; cursor: default; }
    input[type][disabled] + label { color: #999; cursor: default; }
    .margin-left { margin-left: 15px; }
    .img-bg {
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }
    label {
        font: 300 16px/1.7 'Open Sans', sans-serif;
        color: #666;
        cursor: pointer;
    }
</style>